/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

/*
* SearchInfoTemplate
* ==================
*
* A component to display did you mean and search history.
*
*/

define([
    "i18n/i18n",
    "client/template",
    "client/templateregistry",
    "component!base",
    "!!raw-loader!../mustache/template.mustache",
    "backbone"
  ], function(
    i18n,
    Template,
    TemplateRegistry,
    Component,
    DEFAULT_TEMPLATE,
    Backbone
  ) {

    var SearchInfo = Template.extend({

      hasContent: function () {
        return true;
      },

      getDefaultTemplate: function () {
        return DEFAULT_TEMPLATE && DEFAULT_TEMPLATE.default;
      }

    });

    SearchInfo.View = Component.extend({
    });

    return SearchInfo;
});
